export const replaceHashValues = (str, { ...args }) => {
  return str.replace(/##[a-zA-Z0-9]*##/g, item => {
    let replaceValue = "";

    if (typeof args === "object") {
      Object.keys(args).map(key => {
        if (item.split("##")[1] === key) {
          return (replaceValue = args[key]);
        }
        return item;
      });
    }
    return replaceValue;
  });
};
